module.exports = __webpack_public_path__ + "images/sd2-06-desktop.png";